import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "overflow-hidden pb-4 relative w-full"
}
const _hoisted_2 = { class: "flex gap-x-16 text-16px border-b border-gray-lp-400 mb-4" }
const _hoisted_3 = { class: "flex flex-col mt-4 pb-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col",
  style: {"height":"55vh"}
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  style: {"width":"33rem","max-width":"80vw","max-height":"80vh"},
  class: "relative edit-body overflow-y-auto h-full"
}
const _hoisted_8 = { class: "gap-x-3 px-6 pb-6 pt-4 flex justify-center flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "px-4 py-3 mb-6 bg-blue-lp-600 rounded-lg flex-col justify-center items-start gap-2.5 inline-flex"
}
const _hoisted_10 = { class: "justify-start items-center gap-3 inline-flex" }
const _hoisted_11 = { class: "grow shrink basis-0" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text-blue-lp-500 text-xs font-normal font-['Montserrat']" }, " Estimasi keberangkatan: ", -1)
const _hoisted_13 = { class: "text-blue-lp-500 text-xs font-bold font-['Montserrat']" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "my-6" }, null, -1)
const _hoisted_15 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Gamification = _resolveComponent("Gamification")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CardReadyToCargo = _resolveComponent("CardReadyToCargo")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_ConfigFeatureFlight = _resolveComponent("ConfigFeatureFlight")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showModalTest)
      ? (_openBlock(), _createBlock(_component_Gamification, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isEditReadyToCargo)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock("button", {
                key: tab.name,
                onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
                class: 
          `pb-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
            _ctx.isTabActive(tab.name)
              ? 'text-red-lp-100 border-b-2 border-red-lp-100'
              : 'text-gray-lp-600'
          }`
        
              }, [
                (_ctx.isTabActive(tab.name))
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 0,
                      name: _ctx.cargoType(tab.name).icon,
                      class: "w-5 h-5 text-red-lp-100"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(tab.title), 1)
              ], 10, ["onClick"]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_3, [
            (_ctx.readyToCargoList.data.length === 0 && !_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  (!_ctx.destinationCityRTC && !_ctx.clientValue)
                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                        key: 0,
                        data: "Daftar Siap Dikargo"
                      }))
                    : _createCommentVNode("", true),
                  (
            (_ctx.destinationCityRTC || _ctx.clientValue) &&
              _ctx.readyToCargoList.pagination.page === 1
          )
                    ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                        key: 1,
                        class: "mt-4",
                        "error-message": _ctx.errorContainer.errorMessage,
                        "error-title": _ctx.errorContainer.errorTitle,
                        "error-image": _ctx.errorContainer.errorIcon
                      }, null, 8, ["error-message", "error-title", "error-image"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.readyToCargoList.data, (readyToCargo) => {
              return (_openBlock(), _createBlock("div", {
                key: readyToCargo,
                class: "my-2"
              }, [
                _createVNode(_component_CardReadyToCargo, {
                  data: readyToCargo,
                  onOnProcess: _ctx.setShowModalForm,
                  onOnEdit: _ctx.checkForEditReadyToCargo
                }, null, 8, ["data", "onOnProcess", "onOnEdit"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.readyToCargoList.data.length)
      ? (_openBlock(), _createBlock(_component_PaginationV3, {
          key: 2,
          pagination: _ctx.readyToCargoList.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.readyToCargoList.pagination = $event)),
          onSetPage: _ctx.onChangePagination,
          renderedData: _ctx.readyToCargoList.data.length,
          paginationWidth: "w-full",
          class: "absolute bottom-0"
        }, null, 8, ["pagination", "onSetPage", "renderedData"]))
      : _createCommentVNode("", true),
    (!_ctx.isEditReadyToCargo)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_ConfigFeatureFlight, {
            key: _ctx.showSelectAirport,
            onCheckEligible: _ctx.onProcessSelectSchedule,
            onClosePopup: _ctx.closePopUpPlane
          }, null, 8, ["onCheckEligible", "onClosePopup"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModalForm)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_Dialog, {
            class: "dialog-airport",
            modelValue: _ctx.showModalForm,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModalForm = $event)),
            title: "Lengkapi data booking",
            persistent: "",
            customBody: "py-3",
            onReset: _ctx.onReset,
            showOverflow: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  (_ctx.formBooking.cargoType === 'plane')
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, [
                          _createVNode(_component_Icons, {
                            name: "info",
                            class: "w-5 text-blue-lp-500"
                          }),
                          _createVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.estimationNextDeparture), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataWrapper, {
                    class: "my-2",
                    label: "Komoditas Group (Kargo)",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomDropdown, {
                        class: "w-full",
                        placeholder: "Pilih komoditas",
                        options: _ctx.commodityOptions,
                        onSelect: _ctx.onSelectCommodity,
                        selectedItem: _ctx.commodityItem,
                        isCustomWidth: ""
                      }, null, 8, ["options", "onSelect", "selectedItem"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Tipe produk kargo",
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectCargoProduct,
                        onCloseSelect: _ctx.onCloseSelectCargoProduct,
                        isOpenMenu: _ctx.isOpenSelectCargoProduct,
                        value: _ctx.formBooking.cargoProduct,
                        onChooseSelect: _ctx.onSelectCargoProduct,
                        dataSelect: _ctx.listProductCargo,
                        customClass: "w-full",
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }),
                  (_ctx.isCargoPlaneManual || _ctx.isCargoPlaneAuto)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: "NOG",
                        optional: "",
                        class: "w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LpInput, {
                            onChange: _ctx.onChangeNog,
                            modelValue: _ctx.formBooking.nog,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formBooking.nog = $event)),
                            placeholder: "Masukan NOG"
                          }, null, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isCargoPlaneManual || _ctx.isCargoPlaneAuto)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 2,
                        label: "SHC",
                        optional: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LpInput, {
                            disabled: "",
                            disableBackground: "",
                            modelValue: _ctx.shcValue,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.shcValue = $event)),
                            placeholder: "Masukan SHC"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isCargoShip || _ctx.isCargoTrain)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 3,
                        label: "No. Kargo",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LpInput, {
                            onChange: _ctx.onChangeCargoNumber,
                            modelValue: _ctx.formBooking.cargoNumber,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formBooking.cargoNumber = $event)),
                            placeholder: "Masukan kargo"
                          }, null, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isCargoShip || _ctx.isCargoTrain || _ctx.isCargoTruck)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 4,
                        label: "No. Seri Kendaraan",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LpInput, {
                            onChange: _ctx.onChangeVehicleNumber,
                            modelValue: _ctx.formBooking.vehicleNumber,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formBooking.vehicleNumber = $event)),
                            placeholder: "Masukan No. seri kendaraan"
                          }, null, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_14,
                  _createVNode(_component_lp_button, {
                    textColor: "white",
                    title: "Lanjutkan Booking Cargo",
                    fontWeight: "semibold",
                    color: "red-lp-100",
                    isWidthFull: "",
                    customClass: "py-2 px-8",
                    onClick: _ctx.showModalConfirmationBookCargo,
                    disabled: _ctx.isFormBookingValid
                  }, null, 8, ["onClick", "disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onReset"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowPopup)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 5,
          customWidth: _ctx.isPartial ? '480px' : '360px',
          onSubmit: _ctx.popupModalData?.success?.action,
          onClose: _ctx.popupModalData?.cancel?.action,
          title: _ctx.popupModalData.title,
          message: _ctx.popupModalData.message,
          image: _ctx.popupModalData.image,
          textSuccess: _ctx.popupModalData?.success?.text,
          textCancel: _ctx.popupModalData?.cancel?.text,
          class: "px-8"
        }, null, 8, ["customWidth", "onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}